import React, { useEffect } from 'react';

import clsx from 'clsx';

import { useEventContext } from 'context/EventContext';
import detachTask from 'helpers/detachTask';

import constants from '../../richContentData/constants';
import Alternatives from './components/Alternatives';
import Authors from './components/Authors';
import Faqs from './components/Faqs';
import Integrations from './components/Integrations';
import KeyFeatures from './components/KeyFeatures';
import Options from './components/Options';
import Overview from './components/Overview';
import PopularComparisons from './components/PopularComparisons';
import Pricing from './components/Pricing';
import ProsAndCons from './components/ProsAndCons';
import RelatedArticles from './components/RelatedArticles';
import RelatedCategories from './components/RelatedCategories';
import Slider from './components/Slider';
import Snippets from './components/Snippets';
import TextBase from './components/TextBase';

import classes from './RichContent.module.scss';

const contentTypes = {
  [constants.TYPE_BASE]: TextBase,
  [constants.TYPE_OVERVIEW]: Overview,
  [constants.TYPE_COMPARISONS]: PopularComparisons,
  [constants.TYPE_SLIDER]: Slider,
  [constants.TYPE_FAQS]: Faqs,
  [constants.TYPE_OPTIONS]: Options,
  [constants.TYPE_CATGORIES]: RelatedCategories,
  [constants.TYPE_INTEGRATIONS]: Integrations,
  [constants.TYPE_KEY_FEATURES]: KeyFeatures,
  [constants.TYPE_RELATED_ARTICLES]: RelatedArticles,
  [constants.TYPE_PRICING]: Pricing,
  [constants.TYPE_PROS_CONS]: ProsAndCons,
  [constants.TYPE_ALTERNATIVES]: Alternatives,
  [constants.TYPE_AUTHORS]: Authors,
  [constants.TYPE_SNIPPETS]: Snippets,
};

/** @type {import("./types").default} */
const RichContent = ({
  richContent,
  className,
  bxListing,
  articles,
  alternatives,
  authors,
  afterFirstItem,
}) => {
  const { sendEvent } = useEventContext();

  useEffect(() => {
    const dataListener = (event) => {
      const target = event.target.closest('a:not(.prevent-event)');

      if (!target || target.dataset.evtId) {
        return;
      }

      detachTask(sendEvent, {
        name: 'engagement_product_click',
        engagementComponent: 'inline-links',
        engagementDestination: 'go-to_other-page',
        engagementDetails: 'text-link_content-rich',
      });
    };

    window.document
      .getElementById('RichContent')
      ?.addEventListener('mousedown', dataListener);

    return () => {
      window.document
        .getElementById('RichContent')
        ?.removeEventListener('mousedown', dataListener);
    };
  }, [sendEvent]);

  return (
    <div
      id="RichContent"
      className={clsx('RichContent', classes.root, className)}
    >
      {richContent.content.map((content, index) => {
        const Component = contentTypes[content.type];

        return (
          <React.Fragment key={`rich_content_${index}`}>
            {Component ? (
              <div
                id={content?.id}
                className={content?.id ? 'ContentItem' : ''}
              >
                <Component
                  {...content}
                  bxListing={bxListing}
                  articles={articles}
                  alternatives={alternatives}
                  authors={authors}
                />
              </div>
            ) : (
              <div>Undefined Content type: {content.type}</div>
            )}
            {index === 0 && afterFirstItem}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default RichContent;
